/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CheckPartnerActiveOpportunityByOtherUser200Response,
  CreateOpportunityDto,
  Opportunity,
  RecurringPlan,
  Stage,
  UpdateOpportunityDto,
} from '../models/index';
import {
    CheckPartnerActiveOpportunityByOtherUser200ResponseFromJSON,
    CheckPartnerActiveOpportunityByOtherUser200ResponseToJSON,
    CreateOpportunityDtoFromJSON,
    CreateOpportunityDtoToJSON,
    OpportunityFromJSON,
    OpportunityToJSON,
    RecurringPlanFromJSON,
    RecurringPlanToJSON,
    StageFromJSON,
    StageToJSON,
    UpdateOpportunityDtoFromJSON,
    UpdateOpportunityDtoToJSON,
} from '../models/index';
import { useAuthStore } from '@/stores/useAuthStore'

export interface CheckPartnerActiveOpportunityByOtherUserRequest {
    partnerId: number;
}

export interface CreateOpportunityRequest {
    createOpportunityDto: CreateOpportunityDto;
}

export interface GetActiveOpportunitiesByParentIdsRequest {
    ids: Array<string>;
}

export interface GetOpportunitiesRequest {
    date?: string;
    isCheckedDateDeadLine?: boolean;
}

export interface GetOpportunitiesByListParentIdRequest {
    ids: Array<string>;
}

export interface GetOpportunityByIdRequest {
    id: number;
}

export interface UpdateOpportunityRequest {
    id: number;
    updateOpportunityDto: UpdateOpportunityDto;
}

/**
 *
 */
export class OpportunityApi extends runtime.BaseAPI {

    /**
     * Vérifie si le partenaire a une opportunité active attribuée à un autre utilisateur
     */
    async checkPartnerActiveOpportunityByOtherUserRaw(requestParameters: CheckPartnerActiveOpportunityByOtherUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CheckPartnerActiveOpportunityByOtherUser200Response>> {
        if (requestParameters['partnerId'] == null) {
            throw new runtime.RequiredError(
                'partnerId',
                'Required parameter "partnerId" was null or undefined when calling checkPartnerActiveOpportunityByOtherUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/opportunity/partner/{partnerId}/has-active-opportunity`;
        urlPath = urlPath.replace(`{${"partnerId"}}`, encodeURIComponent(String(requestParameters['partnerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CheckPartnerActiveOpportunityByOtherUser200ResponseFromJSON(jsonValue));
    }

    /**
     * Vérifie si le partenaire a une opportunité active attribuée à un autre utilisateur
     */
    async checkPartnerActiveOpportunityByOtherUser(requestParameters: CheckPartnerActiveOpportunityByOtherUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CheckPartnerActiveOpportunityByOtherUser200Response> {
        const response = await this.checkPartnerActiveOpportunityByOtherUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create an opportunity
     */
    async createOpportunityRaw(requestParameters: CreateOpportunityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Opportunity>> {
        if (requestParameters['createOpportunityDto'] == null) {
            throw new runtime.RequiredError(
                'createOpportunityDto',
                'Required parameter "createOpportunityDto" was null or undefined when calling createOpportunity().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/opportunity`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOpportunityDtoToJSON(requestParameters['createOpportunityDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OpportunityFromJSON(jsonValue));
    }

    /**
     * Create an opportunity
     */
    async createOpportunity(requestParameters: CreateOpportunityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Opportunity> {
        const response = await this.createOpportunityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get active opportunities by list parent_id
     */
    async getActiveOpportunitiesByParentIdsRaw(requestParameters: GetActiveOpportunitiesByParentIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Opportunity>>> {
        if (requestParameters['ids'] == null) {
            throw new runtime.RequiredError(
                'ids',
                'Required parameter "ids" was null or undefined when calling getActiveOpportunitiesByParentIds().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/opportunity/{ids}/activeopportunities`;
        urlPath = urlPath.replace(`{${"ids"}}`, encodeURIComponent(String(requestParameters['ids'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OpportunityFromJSON));
    }

    /**
     * Get active opportunities by list parent_id
     */
    async getActiveOpportunitiesByParentIds(requestParameters: GetActiveOpportunitiesByParentIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Opportunity>> {
        const response = await this.getActiveOpportunitiesByParentIdsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all stages
     */
    async getAllStagesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Stage>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/opportunity/stages`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(StageFromJSON));
    }

    /**
     * Get all stages
     */
    async getAllStages(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Stage>> {
        const response = await this.getAllStagesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all recurring plans
     */
    async getAllRecurringPlansRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RecurringPlan>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/opportunity/recurring-plans`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RecurringPlanFromJSON));
    }

    /**
     * Get all recurring plans
     */
    async getAllRecurringPlans(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RecurringPlan>> {
        const response = await this.getAllRecurringPlansRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get an opportunities
     */
    async getOpportunitiesRaw(requestParameters: GetOpportunitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Opportunity>>> {
        const queryParameters: any = {};

        if (requestParameters['date'] != null) {
            queryParameters['date'] = requestParameters['date'];
        }

        if (requestParameters['isCheckedDateDeadLine'] != null) {
            queryParameters['isCheckedDateDeadLine'] = requestParameters['isCheckedDateDeadLine'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/opportunity`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OpportunityFromJSON));
    }

    /**
     * Get an opportunities
     */
    async getOpportunities(requestParameters: GetOpportunitiesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Opportunity>> {
        const response = await this.getOpportunitiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get opportunities by list parent_id
     */
    async getOpportunitiesByListParentIdRaw(requestParameters: GetOpportunitiesByListParentIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Opportunity>>> {
        if (requestParameters['ids'] == null) {
            throw new runtime.RequiredError(
                'ids',
                'Required parameter "ids" was null or undefined when calling getOpportunitiesByListParentId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/opportunity/{ids}/opportunities`;
        urlPath = urlPath.replace(`{${"ids"}}`, encodeURIComponent(String(requestParameters['ids'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OpportunityFromJSON));
    }

    /**
     * Get opportunities by list parent_id
     */
    async getOpportunitiesByListParentId(requestParameters: GetOpportunitiesByListParentIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Opportunity>> {
        const response = await this.getOpportunitiesByListParentIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get an opportunity by id
     */
    async getOpportunityByIdRaw(requestParameters: GetOpportunityByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Opportunity>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getOpportunityById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/opportunity/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OpportunityFromJSON(jsonValue));
    }

    /**
     * Get an opportunity by id
     */
    async getOpportunityById(requestParameters: GetOpportunityByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Opportunity> {
        const response = await this.getOpportunityByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update opportunity by id
     */
    async updateOpportunityRaw(requestParameters: UpdateOpportunityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Opportunity>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateOpportunity().'
            );
        }

        if (requestParameters['updateOpportunityDto'] == null) {
            throw new runtime.RequiredError(
                'updateOpportunityDto',
                'Required parameter "updateOpportunityDto" was null or undefined when calling updateOpportunity().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};
        const authStore = useAuthStore()
        const csrf = authStore.getCoreCsrfToken()
        if (csrf) headerParameters["x-csrf-token"] = csrf

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/opportunity/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateOpportunityDtoToJSON(requestParameters['updateOpportunityDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OpportunityFromJSON(jsonValue));
    }

    /**
     * Update opportunity by id
     */
    async updateOpportunity(requestParameters: UpdateOpportunityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Opportunity> {
        const response = await this.updateOpportunityRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
